<template>
  <v-menu
    v-model="openDate"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="innerValue"
        append-icon="mdi-menu-down"
        readonly
        v-bind="{...attrs, ...$attrs}"
        v-on="on"
        :hide-details="hideDetails"
      >
        <template v-if="primaryLabel" v-slot:label>
          <span class="font-weight-bold primary--text">{{ primaryLabel }}</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="innerValue"
      no-title
      v-bind="$attrs"
      :first-day-of-week="1"
      @input="openDate = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    name: 'BaseDatePicker',

    props: {
      value: { type:String, default:()=> new Date().toISOString().substr(0, 10) },
      primaryLabel: { type:String },
      hideDetails: { type:Boolean }
    },

    data() {
      return {
        innerValue: this.value,
        openDate: false
      } 
    },

    watch: {
      value(val) {
        this.innerValue = val
      },

      innerValue(val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>